import React, { useState } from "react";
import { UserOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import GeneralTableHeader from "../common/general-table-header/GeneralTableHeader";
import AdminsTable from "./components/Admins-Table/AdminsTable";
import AdminsEditorModal from "./components/Admins-Editor-Modal/AdminsEditorModal";
import { IKlearlyAdmin } from "../../interfaces/klearlyAdmin.interface";
import RoleInfo from "../common/role-info/RoleInfo";
import styles from "./Admins.module.css";

export default function Admins() {
  const [editorOpen, setEditorOpen] = useState(false);
  const [editingAdmin, setEditingAdmin] = useState<IKlearlyAdmin | null>(null);
  const [refreshToggle, setRefreshToggle] = useState(0);

  const openCreate = () => {
    setEditingAdmin(null);
    setEditorOpen(true);
  };
  const openEdit = (admin: IKlearlyAdmin) => {
    setEditingAdmin(admin);
    setEditorOpen(true);
  };

  const handleSaved = () => {
    // trigger child refresh via key change
    setRefreshToggle((v) => v + 1);
  };

  return (
    <div className={styles.container}>
      <GeneralTableHeader
        title="Admins"
        description="Create and manage Klearly admins."
        avatarUrl={<UserOutlined style={{ fontSize: 30 }} />}
        actionButtons={[
          <RoleInfo />,
          <Button
            type="primary"
            icon={<PlusCircleOutlined />}
            onClick={openCreate}
          >
            New Admin
          </Button>,
        ]}
      />
      <div key={refreshToggle}>
        <AdminsTable onEdit={openEdit} onCreate={openCreate} />
      </div>
      <AdminsEditorModal
        open={editorOpen}
        onClose={() => setEditorOpen(false)}
        admin={editingAdmin}
        onSaved={handleSaved}
      />
    </div>
  );
}
